export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_INACTIVE = 'INACTIVE';
export const STATUS_CANCELED = 'CANCELED';

export const MEMBER_ROLES = [
    // { id: 'MEMBER', name: 'Team Member' },
    { id: 'MANAGER', name: 'Manager' }
    // { id: 'CO_MANAGER', name: 'Co-Manager' }
];
